// export const BACKEND_URL = 'http://localhost:5000'
// export const BACKEND_URL = "http://192.168.1.15:5000";
// export const BACKEND_URL = 'https://alcalc.herokuapp.com'
export const BACKEND_URL = 'https://alkierz.herokuapp.com'
